import { useField } from "formik";
import { MyRadioInputGroup } from "../../Interfaces";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import React from "react";

export const MultiSelectGroup = (props: MyRadioInputGroup) => {
  const { label, options, description, beforeContent, afterContent, ...inputProps } = props;
  const [field, meta] = useField(inputProps);
  return (
    <Paper sx={{ padding: "1rem" }}>
      <FormControl error={!!(meta.touched && meta.error)}>
        <FormLabel sx={{ color: "var(--color-primary)", fontWeight: "bold", marginBottom: "1rem" }}>
          {label}
        </FormLabel>
        {description && (
          <Typography variant="body1" sx={{ marginBottom: "1rem" }}>
            {description}
          </Typography>
        )}
        <FormGroup {...field}>
          {options.map((option, index) => (
            <FormControlLabel
              control={<Checkbox name={inputProps.name} />}
              key={index}
              sx={{ marginBottom: "1rem" }}
              value={option.value}
              label={
                <div>
                  <div>{option.label}</div>
                  {option.description && (
                    <div
                      style={{
                        fontSize: "0.85rem",
                        color: "#666",
                        marginTop: 0,
                      }}
                    >
                      {option.description}
                    </div>
                  )}
                </div>
              }
            />
          ))}
        </FormGroup>
        {meta.error && <FormHelperText>{meta.error}</FormHelperText>}
      </FormControl>
    </Paper>
  );
};
